  <div id="allegation-case-main-content" class="row">    
      <div class="col-sm-3">
      <ul id="allegation-table-of-contents-nav-list" class="nav nav-pills nav-stacked">
         <!-- Start Attorney Case Detail -->            
         <li [className]="isSet('ALLGN')?'inline active':'inline'"><a (click)="setPanelName('ALLGN')">Allegation&nbsp;Result</a></li>         
         <li [className]="isSet('DSPNR')?'inline active':'inline'"><a (click)="setPanelName('DSPNR')">Disposition&nbsp;Result</a></li>         
         <li [className]="isSet('SUPLD')?'inline active':'inline'"><a (click)="setPanelName('SUPLD')">Supplemental&nbsp;Dispositions</a></li>         
         <li [className]="isSet('PRCDN')?'inline active':'inline'"><a (click)="setPanelName('PRCDN')">Probation&nbsp;Conditions</a></li>
         <li [className]="isSet('RLEVN')?'inline active':'inline'"><a (click)="setPanelName('RLEVN')">Related&nbsp;Events</a></li>
         <li [className]="isSet('RLPRT')?'inline active':'inline'"><a (click)="setPanelName('RLPRT')">Related&nbsp;Parties</a></li>         
        <!-- End Attorney Case Detail -->
      </ul>
      </div>
  
      <div class="col-sm-9">          
            <!-- Begin Allegation Result -->
            <div  *ngIf="panelName === 'ALLGN'"  class="panel panel-default page" id='{{"section-allegation-"+allegations.getIndex()+"-result"}}'>              
              <div *ngIf="allegations.getAdjudicationType() === 'D'" class="panel-collapse collapse in" style="height: auto;">
                <app-allegation-result [allegationResult]="allegations.getAllegationResult()"></app-allegation-result>
              </div>
              <div *ngIf="allegations.getAdjudicationType() === 'U'" class="panel-collapse collapse in" style="height: auto;">
                <app-allegation-undisciplined [allegationUndisciplined]="allegations.getAllegationUndisciplined()"></app-allegation-undisciplined>
              </div>
              <div *ngIf="allegations.getAdjudicationType() === 'MC'" class="panel-collapse collapse in" style="height: auto;">
                <app-allegation-contempt-motion [contemptMotion]="allegations.getAllegationContemptMotion()"></app-allegation-contempt-motion>
              </div>
              <div class="title-bar">
                <h3 id="AllegationResult" class="panel-title summary-label">Allegation Result</h3>
              </div>
            </div>
            <!-- End Allegation Result -->

            <!-- Begin Disposition Result -->
            <div *ngIf="panelName === 'DSPNR'" class="panel panel-default page" id='{{"section-disposition-"+allegations.getIndex()+"-result"}}'>
              <div *ngIf="allegations.getDispositionType() === 'D'" class="panel-collapse collapse in" style="height: auto;">
                <app-disposition-result [dispositionResult]="allegations.getDispositionResult()"></app-disposition-result>
              </div>
              <div *ngIf="allegations.getDispositionType() === 'U'" class="panel-collapse collapse in" style="height: auto;">
                <app-disposition-undisciplined [dispositionUndisciplined]="allegations.getDispositionUndisciplined()"></app-disposition-undisciplined>
              </div>
              <div *ngIf="allegations.getDispositionType() === 'DDO'" class="panel-collapse collapse in" style="height: auto;">
                <app-disposition-delinquent-offense [dispositionDelinquentOffense]="allegations.getDispositionDelinquentOffense()"></app-disposition-delinquent-offense>
              </div>
              <div *ngIf="allegations.getDispositionType() === 'MC'" class="panel-collapse collapse in" style="height: auto;">
                <app-dispostioin-contempt-motion [contemptMotion]="allegations.getDispositionContemptMotion()"></app-dispostioin-contempt-motion>
              </div>
              <div class="title-bar">
                <h3 id="DispositionResult" class="panel-title summary-label">Disposition Result</h3>
              </div>
            </div>
            <!-- End Disposition Result -->

            <!-- Begin Supplemental Dispositions -->
            <div *ngIf="panelName === 'SUPLD'" class="panel panel-default page" id='{{"section-supplemental-dispositions"+allegations.getIndex()+"-result"}}'>
                <div class="panel-collapse collapse in" style="height: auto;">
                  <app-supplemental-dispositions [supplementalDispositions]="allegations.getSupplementalDispositions()"></app-supplemental-dispositions>
                </div>
                <div class="title-bar">
                  <h3 id="SupplementalDispositions" class="panel-title summary-label">Supplemental Dispositions</h3>
                </div>
              </div>
              <!-- End Supplemental Dispositions -->
  
              <!-- Begin Probation Conditions -->
              <div *ngIf="panelName === 'PRCDN'" class="panel panel-default page" id='{{"section-probation-conditions"+allegations.getIndex()+"-result"}}'>
                <div class="panel-collapse collapse in" style="height: auto;">
                  <app-probation-conditions [probationCondition]="allegations.getProbationCondition()"></app-probation-conditions>
                </div>
                <div class="title-bar">
                  <h3 id="ProbationConditions" class="panel-title summary-label">Probation Conditions</h3>
                </div>
              </div>
              <!-- End Probation Conditions -->
              
              <!-- Begin Related Events -->
              <div *ngIf="panelName === 'RLEVN'" class="panel panel-default page" id='{{"section-related-events"+allegations.getIndex()+"-result"}}'>
                <div class="panel-collapse collapse in" style="height: auto;">
                  <app-related-events [relatedEvents]="allegations.getRelatedEvents()"></app-related-events>
                </div>
                <div class="title-bar">
                  <h3 id="RelatedEvents" class="panel-title summary-label">Related Events</h3>
                </div>
              </div>
              <!-- End Related Events -->
  
              <!-- Begin Related Parties -->
              <div *ngIf="panelName === 'RLPRT'" class="panel panel-default page" id='{{"section-related-parties"+allegations.getIndex()}}'>
                <div class="panel-collapse collapse in" style="height: auto;">
                  <app-related-parties [relatedParties]="allegations.getRelatedParties()"></app-related-parties>
                </div>
                <div class="title-bar">
                  <h3 id="RelatedParties" class="panel-title summary-label">Related Parties</h3>
                </div>
              </div>
              <!-- End Related Parties -->
            
            
      <!-- <div style="height:1000px"></div> -->
    </div>
    </div>
<!-- </div> -->


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/allegations-additional-info.component.html